<section *ngIf="tokenValid">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'alreadylogedIn' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/home">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'home' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="!tokenValid">
    <!-- Start breadcrumb Area -->
    <div class="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-inner text-center">
                        <h2 class="title">{{'Become a Teacher' | translate}}</h2>
                        <ul class="page-list">
                            <li class="rbt-breadcrumb-item"><a routerLink="/home">{{'home' | translate}}</a></li>
                            <li>
                                <div class="icon-right"><i class="feather-chevron-right"></i></div>
                            </li>
                            <li class="rbt-breadcrumb-item active">{{'Become a Teacher' | translate}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Breadcrumb Area -->

    <div class="rbt-become-area bg-color-white rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center">
                        <span class="subtitle bg-primary-opacity">{{'INSTRUCTOR' | translate}}</span>
                        <h2 class="title">{{'Apply As Instructor' | translate}}</h2>
                        <p class="description has-medium-font-size mt--20 mb--40">{{'lorem small' | translate}}</p>
                    </div>
                </div>
            </div>

            <div class="row row row--30">

                <div class="col-lg-12 mt_md--40 mt_sm--40 order-2 order-lg-1">
                    <div class="advance-tab-button">
                        <ul class="nav nav-tabs tab-button-style-2" id="myTab-4" role="tablist">
                            <li role="presentation">
                                <a  class="tab-button" id="home-tab-4" data-bs-toggle="tab" data-bs-target="#home-4" role="tab" aria-controls="home-4" aria-selected="false">
                                    <span class="title">{{'Become a Teacher' | translate}}</span>
                                </a>
                            </li>
                            <li role="presentation">
                                <a  class="tab-button active" id="profile-tab-4" data-bs-toggle="tab" data-bs-target="#profile-4" role="tab" aria-controls="profile-4" aria-selected="true">
                                    <span class="title">{{'Intructor Rules' | translate}}</span>
                                </a>
                            </li>
                            <li role="presentation">
                                <a  class="tab-button" id="contact-tab-4" data-bs-toggle="tab" data-bs-target="#contact-4" role="tab" aria-controls="contact-4" aria-selected="false">
                                    <span class="title">{{'Start with courses' | translate}}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="tab-content advance-tab-content-style-2">
                        <div class="tab-pane fade" id="home-4" role="tabpanel" aria-labelledby="home-tab-4">
                            <div class="content">
                                <p>{{'lorem Med' | translate}}</p>
                            </div>
                        </div>
                        <div class="tab-pane fade active show" id="profile-4" role="tabpanel" aria-labelledby="profile-tab-4">
                            <div class="content">
                                <p>{{'lorem Med' | translate}}</p>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="contact-4" role="tabpanel" aria-labelledby="contact-tab-4">
                            <div class="content">
                                <p>{{'lorem Med' | translate}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row pt--60 g-5">
                <div class="col-lg-12">
                    <div class="rbt-contact-form contact-form-style-1 max-width-auto">
                        <div class="section-title text-center">
                            <span class="subtitle bg-primary-opacity">{{'For Become a Instructor' | translate}}</span>
                        </div>
                        <h3 class="title" style="text-align: center;">{{'Instructor Registration' | translate}}</h3>
                        <hr class="mb--30">

                        <form #teacherForm="ngForm" id="teacherForm" novalidate>
                            <div class="row row-15">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input name="firstName" id="firstName" type="text" [(ngModel)]="teacher.firstName" required ngModel required #firstName="ngModel" placeholder="{{'First Name' | translate}}" [maxlength]="150" pattern="[أ-يa-zA-z ]*">
                                        <span class="focus-border"></span>
                                    </div>
                                    <small class="d-block mt_dec--5" *ngIf="firstName.errors?.pattern"><i class="feather-info" style="margin-left: 5px;"></i>يجب أن لا يحتوي الاسم الاول على أرقام أو حروف خاصة</small>
                                </div>
    
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input name="lastName" id="lastName" type="text" [(ngModel)]="teacher.lastName" required ngModel required #lastName="ngModel" placeholder="{{'Last Name' | translate}}" [maxlength]="150" pattern="[أ-يa-zA-z ]*">
                                        <span class="focus-border"></span>
                                    </div>
                                    <small class="d-block mt_dec--5" *ngIf="lastName.errors?.pattern"><i class="feather-info" style="margin-left: 5px;"></i>يجب أن لا يحتوي اسم العائلة على أرقام أو حروف خاصة</small>
                                </div>
                            </div>

                            <div class="row row-15">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input name="userName" id="userName" type="text" [(ngModel)]="teacher.userName" required ngModel required #userName="ngModel" placeholder="{{'User name' | translate}}" [maxlength]="50">
                                        <span class="focus-border"></span>
                                    </div>
                                </div>
    
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input name="mobile" id="mobile" type="text" [(ngModel)]="teacher.mobile" required ngModel required #mobile="ngModel" placeholder="{{'Phone Number' | translate}}" [maxlength]="10" NumbersOnly>
                                        <span class="focus-border"></span>
                                    </div>
                                </div>
                            </div>


                            <div class="row row-15">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input name="email" id="email" type="text" [(ngModel)]="teacher.email" required ngModel required #email="ngModel" placeholder="{{'Email' | translate}}" [email]="true">
                                        <span class="focus-border"></span>
                                    </div>
                                    <small class="d-block mt_dec--5" *ngIf="email.errors?.email"><i class="feather-info" style="margin-left: 5px;"></i>يجب أن يكتب البريد الالكتروني بطريقة صحيحة</small>
                                </div>
    
    
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input name="pass" #input id="pass" type="password" [(ngModel)]="teacher.pass" required ngModel required #pass="ngModel" placeholder="{{'Password' | translate}}" [maxlength]="20" [minlength]="8">
                                        <span class="focus-border"></span>
                                        <i class="feather-eye" style="position: absolute;left: 3%;top: 29%;cursor: pointer;" (click)="changeInput(input)"></i>
                                    </div>

                                    <small class="d-block mt_dec--5"><i class="feather-info" style="margin-left: 5px;margin-bottom: 10px;"></i>يجب أن تحتوي كلمة المرور على حرف كبير و صغير و حرف خاص و رقم</small>
                                </div>
                            </div>

                            <div class="row row-15">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <textarea placeholder="{{'Bio' | translate}}" name="bio" id="bio" type="text" [(ngModel)]="teacher.bio" required ngModel required #bio="ngModel" [maxlength]="200"></textarea>
                                        <span class="focus-border"></span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-submit-group">
                                    <button type="submit" class="rbt-btn btn-md btn-gradient hover-transform-none w-100" (click)="registerTeacher()" [disabled]="!(teacherForm.valid && teacherForm.dirty)">
                                        <span class="icon-reverse-wrapper">
                                            <span class="btn-text">{{'registerNow' | translate}}</span>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
